module.exports = __webpack_public_path__ + "static/img/tougu-map.9845935.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/gotoContent/tougu-map.png
// module id = mRk8
// module chunks = 0